<template>
  <li
    class="nav-item tag-item"
    :class="{ 'has-children': tag.children.length > 0 }"
  >
    <router-link 
      :to="`/account/${accountId}/tag/${tag.id}`"
      class="nav-link"
    >
      <p :style="{ paddingLeft: getIndentation() + 'px' }">
        {{tag.name}}
      </p>
    </router-link>
    <div 
      v-if="userCan(CUP.MANAGE_TAGS)"
      class="actions text-right align-self-center"
    >
      <i
        class="icon-action fa fa-pencil"
        @click="$emit('edit', {tag})"
      ></i>
    </div>
    <button 
      type="button"
      v-if="tag.children.length > 0"
      class="tag-item-action" 
      @click="expanded = !expanded"
    >
      <i
        class="icon-action fa"
        :class="{ 'fa-chevron-down': !expanded, 'fa-chevron-up': expanded }"
      ></i>
    </button>
  </li>
  <Tag
    v-if="expanded"
    v-for="child of tag.children"
    :tag="child"
    :account-id="accountId"
    :indentation-level="indentationLevel ? indentationLevel + 1 : 1"
    @edit="(evt) => $emit('edit', evt)"
  />
</template>


<script setup>
import { inject, ref } from 'vue';
import { CORE_USER_PERMISSIONS as CUP } from '@/enums/CoreUserPermissions';

const props = defineProps(['tag', 'accountId', 'indentationLevel']);
const emit = defineEmits(['edit']);
const userCan = inject('userCan');
const expanded = ref(false);

function getIndentation() {
  return props.indentationLevel * 10;
}
</script>


<style scoped>
.tag-item {
  display: flex;
  align-items: center;
}

.tag-item .nav-link {
  flex: 1;
}

.actions {
  display: none;
  padding-inline: 20px;
}

.has-children .actions {
  padding-inline: 10px;
}

.tag-item-action {
  appearance: none;
  border: 0;
  background-color: transparent;
  color: inherit;
  padding-left: 10px;
  padding-right: 20px;
}

.icon-action {
  cursor: pointer;
  color: #fff;
  filter: brightness(0.8);
}

.icon-action:hover {
  filter: brightness(1);
}

.icon-action.disabled {
  filter: brightness(0.5);
}

.tag-item:hover .actions {
  display: block;
}
</style>
